import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

export const CustomSectionForm = ({ section, onChange, onDeleteSection }) => {
  const addItem = () => {
    const newItem = {
      id: Date.now().toString(),
      name: '',
      description: '',
      link: ''
    };
    onChange({ ...section, items: [...section.items, newItem] });
  };

  const removeItem = (itemId) => {
    onChange({ ...section, items: section.items.filter(item => item.id !== itemId) });
  };

  const updateItem = (itemId, field, value) => {
    onChange({
      ...section,
      items: section.items.map(item => 
        item.id === itemId ? { ...item, [field]: value } : item
      )
    });
  };

  const updateTitle = (newTitle) => {
    onChange({ ...section, title: newTitle });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4 mb-6 pb-6 border-b border-gray-100">
         <Input 
           label="Section Title" 
           value={section.title} 
           onChange={(e) => updateTitle(e.target.value)}
           className="flex-1"
         />
         <div className="mt-6">
            <Button variant="outline" onClick={onDeleteSection} className="text-red-500 hover:text-red-700 hover:bg-red-50 border-red-200">
                <Trash2 size={18} />
            </Button>
         </div>
      </div>

      {section.items.map((item, index) => (
        <div key={item.id} className="p-4 bg-gray-50 rounded-lg border border-gray-200 relative group">
          <div className="absolute top-4 right-4">
             <button onClick={() => removeItem(item.id)} className="text-gray-400 hover:text-red-500 transition-colors">
                <Trash2 size={18} />
             </button>
          </div>
          
          <div className="grid grid-cols-1 gap-4">
            <Input 
              label="Item Name / Title" 
              value={item.name} 
              onChange={(e) => updateItem(item.id, 'name', e.target.value)} 
              placeholder="e.g. Project Name"
            />
             <Input 
              label="Link (Optional)" 
              value={item.link || ''} 
              onChange={(e) => updateItem(item.id, 'link', e.target.value)} 
              placeholder="e.g. github.com/project"
            />
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
              <textarea 
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 min-h-[80px]"
                value={item.description}
                onChange={(e) => updateItem(item.id, 'description', e.target.value)}
              />
            </div>
          </div>
        </div>
      ))}
      
      <Button onClick={addItem} variant="outline" className="w-full border-dashed">
        <Plus size={18} className="mr-2" /> Add Item
      </Button>
    </div>
  );
};
